import RecaptchaFormControl from 'account/RecaptchaFormControl';
import FormControlWithBtnDisablingAndRecaptcha from 'global/form/formControlWithBtnDisablingAndRecaptcha';

export default function getQuote() {
	const getQuoteForm = document.getElementById('getQuotePageForm');

	if (getQuoteForm) {
		new FormControlWithBtnDisablingAndRecaptcha(getQuoteForm);
		new RecaptchaFormControl(getQuoteForm);
	}
}
